// import PropTypes from "prop-types"
import React from 'react';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import headteam from './getHeadTeam';
import './who.is.less';
import useGlobalData from '../../../providers/globalDataProvider/globalDataProvider.useGlobalData';

const getName = (fileName) => {
  const splited = fileName.split('_');
  return splited[1] || 'N/A';
};

const getPosition = (fileName) => {
  const splited = fileName.split('_');
  const position = splited[2] || 'N/A';
  return position.split('.').slice(0, -1).join('.');
};

const ImageComponent = ({ p }) => {
  const name = getName(p.node.relativePath);
  const position = getPosition(p.node.relativePath);
  return (
    <div className="m-whoIs__teamIndividual">
      <GatsbyImage
        image={getImage(p.node)}
        className="a-whoIs__avatar"
        title={name}
        alt={`Lidya's ${position} ${name}`}
        style={{ display: 'block' }}
      />
      <div className="a-whoIs__nameContainer">
        <div>
          <p className="a-whoIs__nameText">{name}</p>
          <p className="a-whoIs__positionText">{position}</p>
        </div>
      </div>
    </div>
  );
};

const Steps = () => {
  const { country } = useGlobalData();
  const { t } = useTranslation();
  const headList = headteam();
  const textwithCountry = t(`web.about.who.is.title.fourth.${country}`);
  const finalText = textwithCountry || t('web.about.who.is.title.fourth');
  return (
    <div className="o-whoIs">
      <div className="m-globalContentContainer">
        <div className="m-whoIs__titleContainer">
          <h1 className="a-whoIs__title -page-title">
            {t('web.about.who.is.title')}
          </h1>
        </div>
        <h2 className="a-whoIs__subTitleTop">{t('web.about.sub.title.top')}</h2>
        <div className="m-whoIs__teamContainer">
          <div className="m-whoIs__subTitleContainer">
            <p className="a-whoIs__subTitle">
              <span className="a-whoIs__span">Lidya </span>
              {t('web.about.who.is.sub.title.one')}
            </p>
          </div>
          <div className="m-whoIs__teamIndividualContainer">
            <ImageComponent
              p={headList[0]}
              className="a-whoIs__extraSvg -first"
            />
          </div>
          <div className="m-whoIs__subTitleContainer">
            <p className="a-whoIs__subTitle">
              {`${t('web.about.who.is.title.third')} `}
              <span className="a-whoIs__span">
                {t('web.about.who.is.sub.title.third')}
              </span>
              {t('web.about.who.is.sub.sub.title.third')}
            </p>
          </div>

          <div className="m-whoIs__teamIndividualContainer">
            <ImageComponent
              p={headList[1]}
              className="a-whoIs__extraSvg -first"
            />
            <ImageComponent
              p={headList[2]}
              className="a-whoIs__extraSvg -first"
            />
          </div>
          <div className="m-whoIs__subTitleContainer">
            <p className="a-whoIs__subTitle">{finalText}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Steps;
